'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n'], ['\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    opacity: 1;\n    height: 50px;\n    transition: all 0.25s ease-in-out;\n'], ['\n    opacity: 1;\n    height: 50px;\n    transition: all 0.25s ease-in-out;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _alignments = require('../../constants/alignments');

var _sizes = require('../../constants/sizes');

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _header = require('../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _link = require('../../atoms/link');

var _link2 = _interopRequireDefault(_link);

var _spinner = require('../../atoms/icons/spinner');

var _spinner2 = _interopRequireDefault(_spinner);

var _redirect = require('../../atoms/redirect');

var _redirect2 = _interopRequireDefault(_redirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RedirectContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject);

var SpinnerContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject2);

var ExternalRedirect = function (_React$Component) {
    _inherits(ExternalRedirect, _React$Component);

    function ExternalRedirect() {
        _classCallCheck(this, ExternalRedirect);

        return _possibleConstructorReturn(this, (ExternalRedirect.__proto__ || Object.getPrototypeOf(ExternalRedirect)).apply(this, arguments));
    }

    _createClass(ExternalRedirect, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                RedirectContainer,
                { fullSize: true,
                    isMobile: this.context.screen.isMobile,
                    left: !this.props.nogutter && _sizes.Sizes.xs,
                    right: !this.props.nogutter && _sizes.Sizes.xs,
                    bottom: _sizes.Sizes.xl
                },
                _react2.default.createElement(
                    _container2.default,
                    { bottom: _sizes.Sizes.xl },
                    _react2.default.createElement(
                        _grid2.default,
                        null,
                        _react2.default.createElement(
                            _row2.default,
                            null,
                            _react2.default.createElement(
                                _column2.default,
                                { xs: 12 },
                                _react2.default.createElement(
                                    SpinnerContainer,
                                    { top: _sizes.Sizes.xl, bottom: _sizes.Sizes.sm, horizontalAlignment: _alignments.Alignments.center },
                                    _react2.default.createElement(_spinner2.default, { size: _sizes.Sizes.xl })
                                ),
                                this.props.headerText && _react2.default.createElement(_header2.default, {
                                    textAlign: _alignments.Alignments.center,
                                    top: _sizes.Sizes.md,
                                    bottom: _sizes.Sizes.xs,
                                    size: _sizes.Sizes.md,
                                    text: this.props.headerText
                                }),
                                this.props.labelText && _react2.default.createElement(_label2.default, {
                                    top: _sizes.Sizes.xs,
                                    bottom: _sizes.Sizes.xs,
                                    textAlign: _alignments.Alignments.center,
                                    text: this.props.labelText
                                }),
                                this.props.linkText && _react2.default.createElement(_link2.default, {
                                    top: _sizes.Sizes.sm,
                                    size: _sizes.Sizes.md,
                                    text: this.props.linkText,
                                    href: this.props.target
                                }),
                                _react2.default.createElement(_redirect2.default, { target: this.props.target, timeout: this.props.timeout })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ExternalRedirect;
}(_react2.default.Component);

ExternalRedirect.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = ExternalRedirect;